var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeatPumpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 52,
    viewBox: "0 0 60 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1666 26.6403H42.1922C41.4836 26.6403 40.9102 26.0669 40.9102 25.3582C40.9102 24.6496 41.4836 24.0762 42.1922 24.0762H51.1666C51.8752 24.0762 52.4486 24.6496 52.4486 25.3582C52.4486 26.0669 51.8752 26.6403 51.1666 26.6403Z",
    fill: "url(#paint0_linear_3158_27913)",
    stroke: "#1B2D51",
    strokeWidth: 0.242897
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1666 33.0529H42.1922C41.4836 33.0529 40.9102 32.4795 40.9102 31.7708C40.9102 31.0622 41.4836 30.4888 42.1922 30.4888H51.1666C51.8752 30.4888 52.4486 31.0622 52.4486 31.7708C52.4486 32.4795 51.8752 33.0529 51.1666 33.0529Z",
    fill: "url(#paint1_linear_3158_27913)",
    stroke: "#1B2D51",
    strokeWidth: 0.242897
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1666 39.4616H42.1922C41.4836 39.4616 40.9102 38.8881 40.9102 38.1795C40.9102 37.4709 41.4836 36.8975 42.1922 36.8975H51.1666C51.8752 36.8975 52.4486 37.4709 52.4486 38.1795C52.4486 38.8881 51.8752 39.4616 51.1666 39.4616Z",
    fill: "url(#paint2_linear_3158_27913)",
    stroke: "#1B2D51",
    strokeWidth: 0.242897
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1666 19.5908H42.1922C41.4836 19.5908 40.9102 19.0174 40.9102 18.3087V9.97541C40.9102 9.26676 41.4836 8.69336 42.1922 8.69336H51.1666C51.8752 8.69336 52.4486 9.26678 52.4486 9.97541V18.3087C52.4486 19.0174 51.8752 19.5908 51.1666 19.5908ZM43.4743 17.0267H49.8845V11.2575H43.4743V17.0267Z",
    fill: "url(#paint3_linear_3158_27913)",
    stroke: "#1B2D51",
    strokeWidth: 0.767079
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9666 11.2575C30.0352 11.2575 35.7872 17.0092 35.7872 24.078C35.7872 31.1468 30.0354 36.8985 22.9666 36.8985C15.8979 36.8985 10.1461 31.1468 10.1461 24.078C10.1461 17.0092 15.8979 11.2575 22.9666 11.2575ZM22.9666 8.69336C14.4679 8.69336 7.58203 15.5793 7.58203 24.078C7.58203 32.5767 14.4679 39.4626 22.9666 39.4626C31.4654 39.4626 38.3513 32.5767 38.3513 24.078C38.3513 15.5793 31.4654 8.69336 22.9666 8.69336Z",
    fill: "url(#paint4_linear_3158_27913)",
    stroke: "#1B2D51",
    strokeWidth: 0.767079
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6681 23.417C29.6576 22.6536 28.4327 22.2643 27.0263 22.2643C26.6151 22.2643 26.2149 22.2993 25.8321 22.354C25.5718 21.8553 25.1913 21.4288 24.7275 21.116C24.99 20.8251 25.2875 20.613 25.6177 20.5495C26.1186 20.4511 26.8185 20.4664 27.4462 20.5014C27.7262 20.5167 27.9952 20.532 28.2468 20.532C28.7236 20.532 29.8369 20.532 30.3093 19.4734C30.4712 19.1104 30.4493 18.6838 30.2437 18.207C29.6641 16.8619 27.5578 15.1209 25.738 14.4844C24.734 14.1322 23.7673 13.9551 22.8618 13.9551C20.4427 13.9551 18.7804 15.2521 18.5201 17.3409C18.2796 19.2679 19.0844 20.882 20.0337 22.0806C19.7406 22.5334 19.5525 23.0627 19.5066 23.6314C19.1413 23.5526 18.7914 23.4105 18.5639 23.1502C18.1658 22.693 17.8837 22.1331 17.6081 21.5907C17.0897 20.5649 16.5473 19.4909 15.2852 19.6243C14.8894 19.6659 14.5306 19.8977 14.2223 20.3133C13.3474 21.4879 12.8924 24.1826 13.2489 26.0767C13.8373 29.2001 15.633 31.2189 17.8225 31.2189C18.3233 31.2189 18.8308 31.1117 19.3295 30.9018C21.1011 30.1537 22.0963 28.6729 22.6606 27.2622C22.7219 27.2666 22.7853 27.2709 22.8465 27.2709C23.3671 27.2709 23.8592 27.1485 24.2989 26.9385C24.4104 27.2994 24.441 27.6515 24.3339 27.9621C24.137 28.5329 23.7936 29.0601 23.4612 29.5675C22.8597 30.4905 22.1751 31.536 22.9209 32.5619C23.2074 32.9578 23.7105 33.159 24.4148 33.159C25.9109 33.159 28.2031 32.236 29.5264 31.1008C31.2521 29.6179 32.2123 27.8462 32.1598 26.2364C32.1292 25.1012 31.6086 24.1279 30.6681 23.417L30.6681 23.417ZM18.4565 28.8304C18.2334 28.9244 18.0191 28.9726 17.8201 28.9726C16.7921 28.9726 15.8166 27.6077 15.4491 25.6567C15.2654 24.6812 15.4032 23.476 15.6219 22.6252C15.9237 23.2223 16.2999 23.9594 16.873 24.6178C17.6166 25.4707 18.7321 25.9126 20.1845 25.9454C20.307 26.1051 20.4448 26.2538 20.5935 26.3894C20.2042 27.3693 19.5524 28.3689 18.4566 28.8304L18.4565 28.8304ZM22.8485 25.0246C22.2317 25.0246 21.7308 24.5215 21.7308 23.9025C21.7308 23.2857 22.2317 22.7827 22.8485 22.7827C23.4675 22.7827 23.9706 23.2836 23.9706 23.9025C23.9706 24.5215 23.4675 25.0246 22.8485 25.0246ZM22.352 20.5845C22.1661 20.6129 21.9846 20.6523 21.8096 20.7092C21.1447 19.878 20.5935 18.8041 20.7422 17.6143C20.8604 16.6716 21.5734 16.1925 22.8617 16.1925C23.5047 16.1925 24.2441 16.3325 24.9964 16.5972C25.9326 16.9253 26.9103 17.6471 27.5358 18.2639C27.2427 18.2486 26.9103 18.2289 26.5669 18.2289C26.0573 18.2289 25.6045 18.2682 25.1845 18.3514C23.8853 18.6051 22.9754 19.5565 22.3521 20.5845L22.352 20.5845ZM28.0717 29.3922C27.3631 30.0024 26.2541 30.5121 25.3595 30.7571C25.7248 30.1971 26.1732 29.5038 26.4575 28.6814C26.8818 27.45 26.5297 26.2054 25.9676 25.1621C26.0441 24.974 26.1053 24.7793 26.1469 24.5759C26.4334 24.5344 26.7265 24.5037 27.0284 24.5037C27.9492 24.5037 28.6972 24.7312 29.3206 25.2037C29.7209 25.5055 29.9155 25.8555 29.9286 26.2994C29.9549 27.2137 29.2615 28.3686 28.0717 29.3922L28.0717 29.3922Z",
    fill: "url(#paint5_linear_3158_27913)",
    stroke: "#1B2D51",
    strokeWidth: 0.242897
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7301 1H6.29422C3.47473 1 1.16602 3.30872 1.16602 6.12821V42.0256C1.16602 44.8451 3.47473 47.1538 6.29422 47.1538H8.85832V49.7179C8.85832 50.4266 9.43174 51 10.1404 51H17.1917C17.9003 51 18.4737 50.4266 18.4737 49.7179V47.1538H41.5506V49.7179C41.5506 50.4266 42.124 51 42.8327 51H49.884C50.5926 51 51.166 50.4266 51.166 49.7179V47.1538H53.7301C56.5496 47.1538 58.8583 44.8451 58.8583 42.0256V6.12821C58.8583 3.30872 56.5496 1 53.7301 1ZM15.9096 48.4359H11.4224V47.1538H15.9096V48.4359ZM48.6019 48.4359H44.1147V47.1538H48.6019V48.4359ZM56.2942 42.0256C56.2942 43.4404 55.1449 44.5897 53.7301 44.5897H6.29422C4.87948 44.5897 3.73012 43.4404 3.73012 42.0256V6.12821C3.73012 4.71346 4.87948 3.5641 6.29422 3.5641H53.7301C55.1449 3.5641 56.2942 4.71346 56.2942 6.12821V42.0256Z",
    fill: "url(#paint6_linear_3158_27913)",
    stroke: "#1B2D51",
    strokeWidth: 0.767079
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3158_27913",
    x1: 51.2277,
    y1: 24.1243,
    x2: 49.5087,
    y2: 19.5311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3158_27913",
    x1: 51.2277,
    y1: 30.5369,
    x2: 49.5087,
    y2: 25.9437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3158_27913",
    x1: 51.2277,
    y1: 36.9456,
    x2: 49.5087,
    y2: 32.3524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3158_27913",
    x1: 51.2277,
    y1: 8.89782,
    x2: 41.1995,
    y2: 2.59301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3158_27913",
    x1: 35.0954,
    y1: 9.27067,
    x2: 7.5095,
    y2: -7.1094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3158_27913",
    x1: 30.1477,
    y1: 14.3154,
    x2: 13.0038,
    y2: 4.22522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3158_27913",
    x1: 52.7536,
    y1: 1.93812,
    x2: 5.1425,
    y2: -30.6819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatPumpIcon);
export default __webpack_public_path__ + "static/media/heat_pump_icon.ac84fd0ca153ca81589edf8d234eda61.svg";
export { ForwardRef as ReactComponent };